import { useCallback, useEffect, useMemo, useState } from "react";
import { getPlaceNotes } from "../services/placeNoteService";
import { PlaceNote } from "../types/PlaceNote";

export function usePlaceNotes(placeId: string) {
  const [placeNotes, setPlaceNotes] = useState<PlaceNote[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchPlaceNotes = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    setPlaceNotes([]);

    try {
      const placeNotes = await getPlaceNotes(placeId);
      setPlaceNotes(placeNotes);
    } catch (err) {
      setError(err as Error);
    } finally {
      setIsLoading(false);
    }
  }, [placeId]);

  const refetchPlaceNotes = useCallback(() => {
    fetchPlaceNotes();
  }, [fetchPlaceNotes]);

  useEffect(() => {
    fetchPlaceNotes();
  }, [fetchPlaceNotes]);

  return useMemo(() => {
    return {
      noteCount: placeNotes.length,
      placeNotes,
      loading: isLoading,
      error,
      refetch: refetchPlaceNotes,
    };
  }, [placeNotes, isLoading, error, refetchPlaceNotes]);
}
